var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.boxStyles)},[_c('span',{style:(_vm.textStyles)},[_vm._v(_vm._s(_vm.grid_translator.letter))])])
}
var staticRenderFns = []

export { render, staticRenderFns }